import { useEffect, useMemo, useState } from 'react'
import { Modal } from 'stories/components'
import { RenderInput } from 'utils/RenderInput'

import { loanRepurchaseInputs } from './constants'
import { type ILoanRepurchase, emptyLoanRepurchase } from './types'

export const EditLoanRepurchaseDialog = ({
  item,
  loanOptions,
  onClose,
  onSave,
}: {
  item: Partial<ILoanRepurchase> | null
  loanOptions: Record<string, string>
  onClose: () => void
  onSave: (data: Partial<ILoanRepurchase>) => Promise<void>
}) => {
  const [form, setForm] = useState<Partial<ILoanRepurchase>>(emptyLoanRepurchase())
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!item) return
    setForm({ ...item })
  }, [item])

  const inputs = useMemo(() => loanRepurchaseInputs(form, loanOptions), [form, loanOptions])

  if (!item) return null

  const onChange = (key: string, value: any) => {
    setForm((prev) => ({ ...prev, [key]: value }))
  }

  const onSubmit = async () => {
    setSaving(true)
    try {
      await onSave({
        loanId: form.loanId,
        repurchasePrice: Number(form.repurchasePrice || 0),
        reason: form.reason,
      })
      onClose()
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal
      isOpen
      title={item.id ? 'Edit Repurchase' : 'Add Repurchase'}
      loading={saving}
      disabled={!form.loanId?.trim()}
      onOk={onSubmit}
      onClose={onClose}
      titleOkay="Save"
      titleCancel=""
    >
      <div className="grid grid-cols-1 gap-4 p-2">
        {Object.keys(inputs).map((key) => (
          <div key={key} className={inputs[key].span === 'full' ? 'col-span-full' : ''}>
            <RenderInput input={inputs[key]} Key={key} onChange={onChange} />
          </div>
        ))}
      </div>
    </Modal>
  )
}
